import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaTwitter, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const parts = location.pathname.split('/').filter(Boolean);
    const first = parts[0];
    const supported = ['en', 'pt', 'es'];
    const prefix = supported.includes(first) ? `/${first}` : `/${i18n.language}`;

    return (
        <>
            <div className="pre-footer">
                <div className="container">
                    <div className="pre-footer-content">
                        <div className="social-links">
                            <a href="https://facebook.com/jobya" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                <FaFacebook />
                            </a>
                            <a href="https://instagram.com/jobya" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                <FaInstagram />
                            </a>
                            <a href="https://twitter.com/jobya" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                                <FaTwitter />
                            </a>
                            <a href="https://linkedin.com/company/jobya" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                                <FaLinkedin />
                            </a>
                        </div>

                        <div className="app-links">
                            <a
                                href="https://apps.apple.com/app/jobya-pro/id6747011474"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="app-link"
                            >
                                <img src="/images/storebadge/appstore_en.svg"
                                    style={{ height: 40 }}
                                    alt="Download on App Store"
                                />
                            </a>
                            <a
                                href="https://play.google.com/store/apps/details?id=br.com.jobyapro"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="app-link"
                            >
                                <img src="/images/storebadge/googleplay_en.png"
                                    style={{ height: 40 }}
                                    alt="Get it on Google Play" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <footer className="footer">
                <div className="container">
                    <div className="footer-content">
                        <img src="/images/logo-200x200_bw.png" alt="Jobya" className="footer-logo" />

                        <div className="footer-links">
                            <Link to={`${prefix}/terms`}>{t('footer.termsOfUse')}</Link>
                            <Link to={`${prefix}/privacy`}>{t('footer.privacyPolicy')}</Link>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Footer;
